import {
    
    UPDATE_AGENT_LOGIN,
    LOGIN_CUSTOMER,
    VERIFY_AGENT_JIRA,
    LOG_OUT_USER,
    DISABLE_JWT,
    LOGIN_MODAL_INSTANCE,
    TEST_INIT,
    UPDATE_FILTER,
    LOGIN_AGENT,
    ADD_REDIRECT_LINK,
    REMOVE_REDIRECT_LINK,
    UPDATE_USER_DETAILS,
    SET_FIRST_LOGIN_FLAG
} from './actionTypes'

import * as Config from '../constants/constants'
import { datadogLogs } from '../datadog'

// ==== Additional Constant Filter objects === 

const defaultFilter = [
    {name: "Knowledge Base", selectorKey: "zendesk", selected: false, counter: "kbCount"},
    {name: "Documentation", selectorKey: "git", selected: false, counter: "docsCount"},
    {name: "Community", selectorKey: "forumbee", selected: false, counter: "communityCount"},
]

const customerFilter = [
    {name: "My Requests", selectorKey: "zendeskRequests", selected: false, counter: "requestCount"}
]

const agentFilter = [
    {name: "Tickets", selectorKey: "zendeskTickets", selected: false, counter: "ticketCount"},
    { name: "Jira", selectorKey: "jiraIssues", selected: false, counter: "jiraCount" }
]

// ==== Initial state object ==== 
const initialState = {
    agentLog: false,
    agentJiraLog: false,
    customerLog: false,
    jwtEnable: false,
    jwtToken: null, 
    userType: null,
    signState: false,
    loginModal: null,
    userName: null,
    userEmail: null,
    userId: null,
    searchFilters: defaultFilter,
    allowDownload:false,
    intercomJWT: null,
    selectedFilter: [],
    selectedFilterNames: [],
    authLevel: null, // ==== enum : okta | zendeek ====

    // displayUserCategory: "agent",
    // displayUserCategory: "customer",
    displayUserCategory: Config.userType,

    redirectLink: null,
    testInit: 175,
    isFirstLogin: false  // Track first login - not persisted
}


const GlobalDetails = (state=initialState, action) => {
    
    switch(action.type){
        case UPDATE_AGENT_LOGIN:
            return {
                ...state,
                agentLog: action.payload
            }
            
            case LOGIN_CUSTOMER:
            window.DatadogRumSetUser(action.payload.userEmail);

            // Log to Datadog: Initial user login
            datadogLogs.logger.info('🔐 LOGIN_CUSTOMER - User logged in', {
                action: 'LOGIN_CUSTOMER',
                hasEmail: !!action.payload.userEmail,
                hasUserId: !!action.payload.userId,
                hasUserName: !!action.payload.userName,
                hasJWT: !!action.payload.intercomJWT,
                email: action.payload.userEmail,
                userId: action.payload.userId,
                userName: action.payload.userName,
                timestamp: new Date().toISOString()
            });

            console.log(action.payload, 'payload test', )
            return{
                ...state,
                // customerLog: action.payload.customerLog,
                jwtEnable: action.payload.jwtEnable,
                // jwtToken: action.payload.jwtToken,
                userType: action.payload.userType,
                signState: action.payload.signState,
                userName: action.payload.userName,
                userEmail: action.payload.userEmail,
                userId: action.payload.userId,
                allowDownload:action.payload.allowDownload,
                authLevel: "zendesk",
                searchFilters: [ ...defaultFilter, ...customerFilter],
                role:action.payload?.role,
                intercomJWT: action.payload?.intercomJWT,
                isFirstLogin: true  // Set flag on fresh login

            }

        case LOGIN_AGENT:
            return{
                ...state,
                signState: action.payload.signState,
                userType: action.payload.userType,
                // authLevel: "okta",
                userName:action.payload?.userName,
                authLevel: "azureAD",
                searchFilters: [ ...defaultFilter, ...agentFilter]
            }
        
        case UPDATE_USER_DETAILS:
            // Log JWT update
            datadogLogs.logger.info('🔄 UPDATE_USER_DETAILS - JWT refreshed', {
                action: 'UPDATE_USER_DETAILS',
                hasEmail: !!state.userEmail,
                hasJWT: !!action.payload.intercom_user_jwt,
                email: state.userEmail,
                timestamp: new Date().toISOString()
            });

            return {
                ...state,
                intercomJWT: action.payload.intercom_user_jwt,
                signState: true,
            };
            
        case VERIFY_AGENT_JIRA:
            return{
                ...state,
                agentLog: action.payload,
                searchFilters: [ ...defaultFilter, ...agentFilter]
            }

        case LOG_OUT_USER:
            return {
                ...state,
                agentLog: false,
                agentJiraLog: false,
                customerLog: false,
                jwtEnable: false,
                jwtToken: null, 
                userType: null,
                signState: false,
                userName: null,
                userEmail: null,
                userId: null,
                allowDownload:false,
                intercomJWT: null,
                searchFilters :defaultFilter,
                selectedFilter: [],
                selectedFilterNames: [],
                redirectLink: null,
                authLevel: null,
                isFirstLogin: false  // Reset flag on logout
            }            
        
        case DISABLE_JWT:
            return {
                ...state,
                jwtEnable: false,
                jwtToken: null
            }

        case LOGIN_MODAL_INSTANCE:
            return {
                ...state,
                loginModal: action.payload
            }

        case SET_FIRST_LOGIN_FLAG:
            return {
                ...state,
                isFirstLogin: action.payload
            }

        case UPDATE_FILTER:
            return {
                ...state,
                selectedFilter: action.payload.keys,
                selectedFilterNames: action.payload.names
            }

        case ADD_REDIRECT_LINK:
            console.log("#### LINK ADDED ####")
            return{
                ...state,
                redirectLink: action.payload.link
            }

        case REMOVE_REDIRECT_LINK:
            return {
                ...state,
                redirectLink: null
            }

        case TEST_INIT:
            // alert("This is from Case!!")
            return{
                ...state,
                testInit: Math.random()
            }

        default: 
            return {...state}
    }
}

export default GlobalDetails;